import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const ArrowClosedSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9997 12.9499L16.2427 8.70691C16.6331 8.31645 17.2662 8.31645 17.6567 8.70691C18.0471 9.09738 18.0471 9.73045 17.6567 10.1209L11.9997 15.7779L6.34265 10.1209C5.95219 9.73045 5.95219 9.09738 6.34265 8.70691C6.73312 8.31645 7.36619 8.31645 7.75665 8.70691L11.9997 12.9499Z"
      fill="currentColor"
    />
  </svg>
);

const ArrowClosed = (props: IIconProps) => <Icon component={ArrowClosedSvg} {...props} />;

export default ArrowClosed;
